export const IGNORED_GQL_ERRORS = [{
  errorCode: 'TIMEOUT'
}, {
  errorCode: 'ABORT'
}, {
  errorMessage: 'Aborting: redirection in progress'
}, {
  errorCode: 'NETWORKERROR',
  status: 0
}];